import{jsx as r}from"react/jsx-runtime";const a=()=>r("div",{className:"h-6 w-full rounded-md bg-gray-300"});export{a as default};
